(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySearch', CompanySearch);

    CompanySearch.$inject = ['$resource', 'ENV'];

    function CompanySearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
